import { renderMenuButton_unstable } from "@fluentui/react-components";
import type { AppMenuButtonState } from ".";

export const renderAppMenuButton = (state: AppMenuButtonState) => {
  return renderMenuButton_unstable(state);
};
